import React from 'react';
import UserManagement from '../components/management/UserManagement';

const UserManagementPage = () => {
  return (
    <div className="user-management-page">
      <UserManagement />
    </div>
  );
};

export default UserManagementPage;